import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-zinc-900 py-12" data-id="element-44">
      <div className="container mx-auto px-6" data-id="element-45">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-46">
          <div className="flex items-center gap-2" data-id="element-47">
            <div className="w-6 h-6 bg-red-600 flex items-center justify-center transform -skew-x-12" data-id="element-48">
              <span className="font-display text-white text-sm leading-none" data-id="element-49">
                8
              </span>
            </div>
            <span className="font-display text-xl tracking-widest text-zinc-400 uppercase" data-id="element-50">
              Iron Eight <span className="text-zinc-600" data-id="element-51">MT</span>
            </span>
          </div>

          <div className="flex gap-6 text-sm text-zinc-500 font-medium uppercase tracking-wider" data-id="element-52">
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              Instagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-54">
              Facebook
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-55">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-56">
              Waiver
            </a>
          </div>
        </div>

        <div className="mt-8 text-center md:text-left text-zinc-600 text-sm" data-id="element-57">
          &copy; {new Date().getFullYear()} Iron Eight Muay Thai. Dallas, TX.
          All rights reserved.
        </div>
      </div>
    </footer>;
}